/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-11-29 13:38:34
 * @LastEditors: 诺
 * @LastEditTime: 2022-04-27 21:11:05
 * @Description: file content
 */
import Vue from "vue/dist/vue.js";
import modalForm from "./components/modal-form";
import modalFormSuccess from "./components/modal-formSuccess";
import modalForm2 from "./components/modal-form2";
import modalHelp from "./components/modal-help";
import modalShare from "./components/modal-share";
import modalPoster from "./components/modal-poster";
import modalPoster2 from "./components/modal-poster2";
import modalQrCode from "./components/modal-qrCode";
import modalTip from "./components/modal-tip";

let myPlugin = {
  options: null,
};
myPlugin.install = function(Vue) {
  Vue.prototype.$modal = {
    form: modalForm,
    formSuccess: modalFormSuccess,
    form2: modalForm2,
    help: modalHelp,
    share: modalShare,
    poster: modalPoster,
    poster2: modalPoster2,
    qrCode: modalQrCode,
    tip: modalTip,
  };
};
Vue.use(myPlugin);
